import { Input, MenuItem } from '@material-ui/core';
import React from 'react';
import { DashboardSelect, DashboardSelectWrapper } from '../../../healtheraComponents';
import useLocationQuery from '../../../hooks/useQuery';
import { REPORTS_SELECT_WITH_LABELS } from '../constants';

const ReportsSelect = () => {
    const { query, changeLocationQuery } = useLocationQuery();

    const handleChangePharmacyType = (event) => {
      changeLocationQuery({
        ...query,
        type: event.target.value,
        page: 0,
      });
    };
  
    return (
      <DashboardSelectWrapper>
        <DashboardSelect
          input={<Input disableUnderline />}
          value={query.type || 'orders_in_red'}
          onChange={handleChangePharmacyType}
          fullWidth
        >
          {REPORTS_SELECT_WITH_LABELS.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </DashboardSelect>
      </DashboardSelectWrapper>
    );
};

export default ReportsSelect;
